import React from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

export const TrendsChartWidget = ({ data }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.25 }}
    className="bg-white border border-slate-200 p-6 rounded-sm h-full"
    data-testid="widget-trends-chart"
  >
    <h2 className="text-xl font-chivo font-bold text-slate-900 mb-4">Financial Trends</h2>
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data?.trends || []}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
        <XAxis dataKey="month" stroke="#64748B" style={{ fontSize: '12px' }} />
        <YAxis stroke="#64748B" style={{ fontSize: '12px' }} />
        <Tooltip contentStyle={{ backgroundColor: '#0F172A', border: 'none', borderRadius: '2px', color: '#F8FAFC' }} />
        <Line type="monotone" dataKey="income" stroke="#10B981" strokeWidth={2} name="Income" />
        <Line type="monotone" dataKey="expenses" stroke="#EF4444" strokeWidth={2} name="Expenses" />
        <Line type="monotone" dataKey="profit" stroke="#0F172A" strokeWidth={2} name="Profit" />
      </LineChart>
    </ResponsiveContainer>
  </motion.div>
);

const PIE_COLORS = ['#0F172A', '#10B981', '#4F46E5', '#F59E0B', '#EF4444', '#06B6D4', '#EC4899', '#84CC16'];

export const TopCategoriesWidget = ({ data }) => {
  const categories = (data?.topCategories || []).slice(0, 8);
  if (categories.length === 0) {
    return (
      <div
        className="border border-dashed border-slate-200 bg-slate-50 rounded-sm p-6 text-center"
        data-testid="widget-top-categories-empty"
      >
        <p className="text-sm font-ibm text-slate-500">No expense data yet. Add expense transactions to see category breakdown.</p>
      </div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="bg-white border border-slate-200 p-6 rounded-sm h-full"
      data-testid="widget-top-categories"
    >
      <h2 className="text-xl font-chivo font-bold text-slate-900 mb-4">Top Expense Categories</h2>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={categories}
            dataKey="amount"
            nameKey="category"
            outerRadius={100}
            innerRadius={50}
            paddingAngle={2}
          >
            {categories.map((_, idx) => (
              <Cell key={`cell-${idx}`} fill={PIE_COLORS[idx % PIE_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ backgroundColor: '#0F172A', border: 'none', borderRadius: '2px', color: '#F8FAFC' }}
            formatter={(value) => `$${Number(value).toLocaleString()}`}
          />
          <Legend wrapperStyle={{ fontSize: '12px' }} />
        </PieChart>
      </ResponsiveContainer>
    </motion.div>
  );
};
